import { useState } from 'react'

// Keyed on the link object, so following the same request's link again clears too.
// Set during render, not in an effect, so the filters typed before never reach the linked read.
export const useClearWhenLinked = (link: object | null, clear: () => void) => {
  const [linked, setLinked] = useState(link)
  if (link !== linked) {
    setLinked(link)
    if (link) clear()
  }
}
